import { render, staticRenderFns } from "./FormTemplateAdd.vue?vue&type=template&id=6290e637&scoped=true&"
import script from "./FormTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./FormTemplateAdd.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateAdd.vue?vue&type=style&index=0&id=6290e637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6290e637",
  null
  
)

export default component.exports